/**
 * PaymentModeBanner — always-visible banner shown ONLY in test/staging.
 * In live (authoritylayer.app) this component renders null.
 *
 * Purpose: make it impossible to confuse staging vs live during checkout
 * QA — Stripe charges and affiliate conversions behave differently in each.
 */
import { IS_TEST_PAYMENT_MODE } from "@/lib/payment-mode";

// Only allow the banner on the isolated tracking QA routes.
// Production pages (/, /pricing, /app/*, etc.) must NEVER show test-mode UI,
// even when the host technically resolves to test mode (e.g. preview domains).
const TRACKING_TEST_ROUTES = ["/awin-test-checkout", "/awin-test-success"];

export function PaymentModeBanner() {
  if (!IS_TEST_PAYMENT_MODE) return null;
  if (typeof window === "undefined") return null;
  const path = window.location.pathname;
  const onTrackingTestRoute = TRACKING_TEST_ROUTES.some((r) => path === r || path.startsWith(r + "/"));
  if (!onTrackingTestRoute) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "#F2A000",
        color: "#0f1318",
        fontFamily: "Inter, system-ui, sans-serif",
        fontSize: 12,
        fontWeight: 700,
        textAlign: "center",
        padding: "4px 12px",
        letterSpacing: 0.4,
        textTransform: "uppercase",
        boxShadow: "0 1px 0 rgba(0,0,0,0.2)",
        pointerEvents: "none",
      }}
    >
      🧪 Stripe TEST mode · No real charges · Conversions in dry-run
    </div>
  );
}
